import { Button, Modal } from 'react-bootstrap';
import { useConfirmationModal } from '../../../Redux/context/modalContext';
import styles from '../style.module.scss';
import React from 'react';

const ConfirmationModal = () => {
  const {
    confirmationModal: { show, message, handleClose, handleConfirm },
  } = useConfirmationModal();
  return (
    <div className="modal_box">
      <Modal
        className="main_modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="p-5">
          <div className="text-center">
            <img src="/svg/confirmation-icon.svg" alt="alt-text" width={64} />
            <h4 className={styles.modal_title}>Thank You</h4>
            <p className={styles.modal_message}>{message}</p>
            <Button className={styles.modal_button} onClick={handleConfirm}>
              Done
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConfirmationModal;
